const toNum = (v) => Number(String(v ?? "").replace(",", ".").split(" ")[0]);

export const isZip = (m) => /cernier|zip/i.test(m?.type ? m.type : m?.name || "");
export const lengthKey = (v) => { const n = toNum(v); return n > 0 ? String(n).replace(".", ",") : null; };
export const sortedLengths = (lengths) => Object.entries(lengths || {}).sort((a, b) => toNum(a[0]) - toNum(b[0]));
export const lengthsLabel = (lengths) => sortedLengths(lengths).map(([k, q]) => `${k} cm: ${q}`).join(" · ");
export const cleanLengths = (rows) => {
  const out = {};
  rows.forEach(({ len, qty }) => { const k = lengthKey(len); const q = toNum(qty); if (k && q >= 0 && Number.isFinite(q)) out[k] = (out[k] || 0) + q; });
  return out;
};
